import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Assert from '../util/Assert';
var SegmentPointComparator = /*#__PURE__*/function () {
  function SegmentPointComparator() {
    _classCallCheck(this, SegmentPointComparator);
  }
  _createClass(SegmentPointComparator, null, [{
    key: "relativeSign",
    value: function relativeSign(x0, x1) {
      if (x0 < x1) return -1;
      if (x0 > x1) return 1;
      return 0;
    }
  }, {
    key: "compare",
    value: function compare(octant, p0, p1) {
      if (p0.equals2D(p1)) return 0;
      var xSign = SegmentPointComparator.relativeSign(p0.x, p1.x);
      var ySign = SegmentPointComparator.relativeSign(p0.y, p1.y);
      switch (octant) {
        case 0:
          return SegmentPointComparator.compareValue(xSign, ySign);
        case 1:
          return SegmentPointComparator.compareValue(ySign, xSign);
        case 2:
          return SegmentPointComparator.compareValue(ySign, -xSign);
        case 3:
          return SegmentPointComparator.compareValue(-xSign, ySign);
        case 4:
          return SegmentPointComparator.compareValue(-xSign, -ySign);
        case 5:
          return SegmentPointComparator.compareValue(-ySign, -xSign);
        case 6:
          return SegmentPointComparator.compareValue(-ySign, xSign);
        case 7:
          return SegmentPointComparator.compareValue(xSign, -ySign);
      }
      Assert.shouldNeverReachHere('invalid octant value');
      return 0;
    }
  }, {
    key: "compareValue",
    value: function compareValue(compareSign0, compareSign1) {
      if (compareSign0 < 0) return -1;
      if (compareSign0 > 0) return 1;
      if (compareSign1 < 0) return -1;
      if (compareSign1 > 0) return 1;
      return 0;
    }
  }]);
  return SegmentPointComparator;
}();
export { SegmentPointComparator as default };